import React from 'react';
import { FadeIn } from './FadeIn';
import { MicroscopeIcon, AlertTriangleIcon, LeafIcon, UtensilsIcon, ListChecksIcon, CoffeeIcon, MoonIcon, NotebookPenIcon, FileTextIcon, FlameIcon } from 'lucide-react';
type Chapter = {
  icon: React.ReactNode;
  title: string;
  desc: string;
};
export function EbookIndex() {
  const chapters: Chapter[] = [{
    icon: <MicroscopeIcon className="w-5 h-5" data-id="element-174" />,
    title: 'Capítulo 1 · La raíz del Endodolor',
    desc: 'El eje Intestino-Endometrio-Inflamación explicado con claridad: por qué tu vientre se inflama y cómo se apaga desde la nutrición.'
  }, {
    icon: <AlertTriangleIcon className="w-5 h-5" data-id="element-175" />,
    title: 'Capítulo 2 · La lista negra',
    desc: 'Gluten, lácteos A1, azúcares refinados y aceites Omega-6: cómo identificarlos, por qué inflaman y cómo retirarlos sin sufrir.'
  }, {
    icon: <LeafIcon className="w-5 h-5" data-id="element-176" />,
    title: 'Capítulo 3 · Tus aliados antiinflamatorios',
    desc: 'Crucíferas, carotenoides, cúrcuma, verdes oscuros, Omega-3 y caldo de huesos: los alimentos que sanan tu vientre.'
  }, {
    icon: <UtensilsIcon className="w-5 h-5" data-id="element-177" />,
    title: 'Capítulo 4 · Recetas Endo-Friendly',
    desc: 'Desayunos, almuerzos, cenas, snacks y postres del protocolo, paso a paso, dentro del mismo ebook.'
  }, {
    icon: <ListChecksIcon className="w-5 h-5" data-id="element-178" />,
    title: 'Capítulo 5 · Protocolo de 21 días',
    desc: 'Semana 1 Detox · Semana 2 Equilibrio Hormonal · Semana 3 Regeneración. Tu hoja de ruta día por día.'
  }, {
    icon: <CoffeeIcon className="w-5 h-5" data-id="element-179" />,
    title: 'Capítulo 6 · Hidratación terapéutica',
    desc: 'Tu rutina de infusiones: jengibre, cúrcuma, frambueso rojo y manzanilla, con cuándo y cómo tomarlas.'
  }, {
    icon: <MoonIcon className="w-5 h-5" data-id="element-180" />,
    title: 'Capítulo 7 · Estilo de vida antiinflamatorio',
    desc: 'Sueño, manejo del estrés, nervio vago y movimiento suave. El complemento que multiplica tus resultados.'
  }, {
    icon: <NotebookPenIcon className="w-5 h-5" data-id="element-181" />,
    title: 'Bitácora + Lista de compras',
    desc: 'Páginas finales del ebook para registrar tus 21 días y una lista lista para usar en el supermercado.'
  }];
  return <section className="py-12 md:py-24 bg-forest text-cream" data-id="element-182">
      <FadeIn className="container mx-auto px-5 max-w-[1100px]" data-id="element-183">
        <div className="text-center mb-8 md:mb-12" data-id="element-184">
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-cream mb-4 md:mb-5 leading-tight" data-id="element-185">
            Esto es lo que vas a leer{' '}
            <span className="italic text-peach" data-id="element-186">dentro del PDF</span>
          </h2>
          <p className="text-sand/80 text-lg max-w-2xl mx-auto" data-id="element-187">
            7 capítulos + bitácora + lista de compras, integrados en un solo
            documento.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mb-6" data-id="element-188">
          {chapters.map((chapter, idx) => <FadeIn key={idx} delay={idx * 0.05} className="flex items-start gap-5 bg-cream/[0.03] border border-cream/10 rounded-2xl p-6 md:p-7 hover:border-peach/30 transition-colors" data-id="element-189">
              <div className="shrink-0 w-12 h-12 rounded-xl bg-peach/10 border border-peach/20 flex items-center justify-center text-peach" data-id="element-190">
                {chapter.icon}
              </div>
              <div data-id="element-191">
                <h3 className="font-serif font-light text-2xl text-cream mb-2 leading-snug" data-id="element-192">
                  {chapter.title}
                </h3>
                <p className="text-sand/80 leading-relaxed" data-id="element-193">{chapter.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        {/* Burgundy banner */}
        <div className="relative overflow-hidden rounded-2xl bg-burgundy/30 border border-peach/20 p-7 md:p-9" data-id="element-194">
          <div className="flex flex-col md:flex-row md:items-center gap-6" data-id="element-195">
            <div className="shrink-0 w-12 h-12 rounded-xl bg-peach/10 border border-peach/20 flex items-center justify-center text-peach" data-id="element-196">
              <FileTextIcon className="w-5 h-5" data-id="element-197" />
            </div>
            <div className="flex-1" data-id="element-198">
              <div className="text-peach text-xs font-semibold tracking-[0.2em] uppercase mb-2" data-id="element-199">
                Un solo archivo · Acceso inmediato
              </div>
              <h3 className="font-serif text-3xl md:text-4xl text-cream mb-2 leading-snug" data-id="element-200">
                Todo el método en{' '}
                <span className="italic text-peach" data-id="element-201">un único PDF</span>
              </h3>
              <p className="text-sand/80" data-id="element-202">
                Antes <span className="line-through" data-id="element-203">$17.00</span> ·{' '}
                <span className="text-peach font-semibold" data-id="element-204">Hoy $6.36</span>
              </p>
            </div>
            <div className="shrink-0" data-id="element-205">
              <span className="inline-flex items-center gap-2 bg-burgundy text-cream rounded-full px-6 py-3 font-semibold whitespace-nowrap" data-id="element-206">
                <FlameIcon className="w-4 h-4 text-peach" data-id="element-207" />
                63% OFF · Solo hoy
              </span>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}